import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DropdownOption } from "admin-common";
import { AbstractService } from "./abstract-service.service";
import { APP_CONFIG, AppConfig } from "./config";
import { Magasin } from "../Models/magasin";
import { AdressGlobalService } from "../shared/Services/adressGlobal.service";

@Injectable({
  providedIn: "root",
})
export class MagasinService extends AbstractService<Magasin, number> {
  url: string;

  constructor(
    http: HttpClient,
    @Inject(APP_CONFIG) config: AppConfig,
    private adressGlobalService: AdressGlobalService,
  ) {
    super(http);
    this.url = `${config.apiEndpoint}/new/magasins`;
  }

  /**
   * Stores as dropdown options for the store pickup ("Wissal Univers (Sétif)"), the option value is the store id.
   * @method toStoreOptions
   */
  toStoreOptions(stores: Magasin[]): DropdownOption[] {
    return stores.map((store) => ({
      label: `${store.name} (${this.adressGlobalService.getWilayaLabel(store.wilaya)})`,
      value: store.id,
    }));
  }
}
